import { useQuery } from '@tanstack/react-query'
import { invoiceKey } from './keys'
import { getInvoice } from 'api/payment'
import { useAuthContext } from 'components/auth/useAuthContext'

interface UseInvoice {
  invoiceId: number
}

export function useInvoice(options: UseInvoice) {
  const { invoiceId } = options

  const { company } = useAuthContext()
  const companyId = company?.id
  if (!companyId) {
    throw new Error('Company ID not found')
  }

  return useQuery({
    queryKey: invoiceKey(invoiceId),
    queryFn: () => getInvoice(invoiceId, companyId),
  })
}
